import { render } from "./Celda-Row-Vacio-Component.vue?vue&type=template&id=3944ac70&scoped=true"
import script from "./Celda-Row-Vacio-Component.vue?vue&type=script&lang=js"
export * from "./Celda-Row-Vacio-Component.vue?vue&type=script&lang=js"

import "./Celda-Row-Vacio-Component.vue?vue&type=style&index=0&id=3944ac70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3944ac70"]])

export default __exports__